import React, { useState } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import * as select from '../../../extractFromState';
import * as searchTypes from '../../../constants/searchTypes';
import { deleteSearchResultOfType, restoreSearchResultOfType } from '../../../actions/searchActions';
import { getKbOrMacroResultSnippet } from '../../../util/kbUtil';
import { setAnchorElementsTarget } from '../../../util';
import {
  SearchAllResult,
  SearchAllResultHeading,
  SearchAllResultTextContainer,
  SearchAllDeleteButton,
} from './Search.styles';

const KbOrMacroSearchResult = ({
  result,
  clickAction,
  resultType,
  index,
  showUndo,
  undoDelete,
  trashResult,
  isSpecialist,
}) => {
  const [processing, setProcessing] = useState(false);
  const snippetTextHtml = getKbOrMacroResultSnippet(result);
  const snippetFullSubheadingHtml = get(result._snippetResult.fullSubheading, 'value', null);

  const getButtonLabel = () => {
    if (showUndo) {
      return 'Undo';
    } else if (processing) {
      return 'Processing...';
    }

    return 'Delete';
  };

  const deleteOrUndo = () => {
    if (showUndo) {
      setProcessing(true);
      undoDelete().then(() => {
        setProcessing(false);
      });
    } else {
      setProcessing(true);
      trashResult().then(() => {
        setProcessing(false);
      });
    }
  };

  const handleDeleteClick = (event) => {
    event.stopPropagation();
    deleteOrUndo();
  };

  return (
    <SearchAllResult onClick={() => clickAction(index, resultType)}>
      <SearchAllResultTextContainer>
        <SearchAllResultHeading>
          Title:&nbsp;
          <span dangerouslySetInnerHTML={{ __html: setAnchorElementsTarget(snippetFullSubheadingHtml) }} />
        </SearchAllResultHeading>
        <SearchAllResultHeading>
          Category:&nbsp;{result.heading || result.category || result.description}
        </SearchAllResultHeading>
        <div dangerouslySetInnerHTML={{ __html: setAnchorElementsTarget(snippetTextHtml) }} />
      </SearchAllResultTextContainer>
      {isSpecialist && searchTypes.isDeleteEnabledForSearchType(resultType) && (
        <SearchAllDeleteButton disabled={processing} onClick={(event) => handleDeleteClick(event)}>
          {getButtonLabel()}
        </SearchAllDeleteButton>
      )}
    </SearchAllResult>
  );
};

const mapStateToProps = (state, { result, resultType }) => ({
  isSpecialist: select.isSpecialist(state),
  showUndo: select.isSearchResultDeleted(state, result, resultType),
});

const mapDispatchToProps = (dispatch, { result, resultType }) => ({
  async undoDelete() {
    await dispatch(restoreSearchResultOfType(result, resultType));
  },
  async trashResult() {
    await dispatch(deleteSearchResultOfType(result, resultType));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(KbOrMacroSearchResult);
